"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkBase = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const Box_1 = require("./Box");
exports.LinkBase = styled_1.default(Box_1.Box.withComponent('a')) `
  cursor: pointer;
`;
exports.LinkBase.defaultProps = {
    palette: 'primary',
};

//# sourceMappingURL=LinkBase.js.map
